export const unitsOfDose = [
  { label: "Kg", value: "KG" },
  { label: "Gm", value: "GM" },
  { label: "mg", value: "MG" },
  { label: "µg", value: "UG" },
  { label: "IU", value: "IU" },
  { label: "Units", value: "UNITS" },
  { label: "mEq", value: "MEQ" },
];

export const unitsOfPerWeightBSA = [
  { label: "Kg", value: "KG" },
  { label: "m2", value: "M2" },
  { label: "none", value: "NONE" },
];

export const unitsPerInterval = [
  { label: "year", value: "YEAR" },
  { label: "month", value: "MONTH" },
  { label: "week", value: "WEEK" },
  { label: "day", value: "DAY" },
  { label: "dose", value: "DOSE" },
  { label: "hr", value: "HR" },
];

export const unitsOfDiluant = [{ label: "ml", value: "ML" }];

export const unitsForPrint = [
  { label: "Tablet", value: "TABLET" },
  { label: "Capsule", value: "CAPSULE" },
  { label: "ml", value: "ML" },
  { label: "Drops", value: "DROPS" },
  { label: "TSF", value: "TSF" },
  { label: "Suppository", value: "SUPPOSITORY" },
  { label: "Gummy", value: "GUMMY" },
  { label: "Sachet", value: "SACHET" },
  { label: "Puff(s)", value: "PUFFS" },
];

export const unitsDurationOfTreatment = [
  { label: "Day(s)", value: "DAY" },
  { label: "Week(s)", value: "WEEK" },
  { label: "Month(s)", value: "MONTH" },
  { label: "Year(s)", value: "YEAR" },
];

export const unitsOfTime = [
  { label: "Minute(s)", value: "MINUTES" },
  { label: "Hour(s)", value: "HOURS" },
];

export const frequency = [
  // { label: "1 hourly", value: "1_HOURLY" },
  // { label: "2 hourly", value: "2_HOURLY" },
  // { label: "3 hourly", value: "3_HOURLY" },
  // { label: "4 hourly", value: "4_HOURLY" },
  { label: "6 hourly", value: "6_HOURLY", IN_A_DAY: 4 },
  { label: "8 hourly", value: "8_HOURLY", IN_A_DAY: 3 },
  { label: "12 hourly", value: "12_HOURLY", IN_A_DAY: 2 },
  { label: "OD", value: "OD", IN_A_DAY: 1 },
  { label: "Once a day", value: "ONCE_A_DAY", IN_A_DAY: 1 },
  { label: "BD", value: "BD", IN_A_DAY: 2 },
  { label: "Twice a day", value: "TWICE_A_DAY", IN_A_DAY: 2 },
  { label: "TDS", value: "TDS", IN_A_DAY: 3 },
  { label: "Three times a day", value: "THREE_TIMES_A_DAY", IN_A_DAY: 3 },
  { label: "QDS", value: "QDS", IN_A_DAY: 4 },
  { label: "Four times a day", value: "FOUR_TIMES_A_DAY", IN_A_DAY: 4 },
  // { label: "Five Times a day", value: "FIVE_TIMES_A_DAY" },
  // { label: "Every alternate day", value: "EVERY_ALTERNATE_DAY" },
  // { label: "Once in 3 days", value: "ONCE_IN_3_DAYS" },
  { label: "Once a week", value: "ONCE_A_WEEK", MIN_IN_A_DAY: 1 },
  { label: "Twice a week", value: "TWICE_A_WEEK", MIN_IN_A_DAY: 1 },
  { label: "3 times a week", value: "3_TIMES_A_WEEK", MIN_IN_A_DAY: 1 },
  { label: "4 times a week", value: "4_TIMES_A_WEEK", MIN_IN_A_DAY: 1 },
  { label: "5 times a week", value: "5_TIMES_A_WEEK", MIN_IN_A_DAY: 1 },
  { label: "Once in 2 weeks", value: "ONCE_IN_2_WEEKS", MIN_IN_A_DAY: 1 },
  { label: "Once in 3 weeks", value: "ONCE_IN_3_WEEKS", MIN_IN_A_DAY: 1 },
  { label: "Once a month", value: "ONCE_A_MONTH", MIN_IN_A_DAY: 1 },
  { label: "Two times a month", value: "TWO_TIMES_A_MONTH", MIN_IN_A_DAY: 1 },
  {
    label: "Three times a month",
    value: "THREE_TIMES_A_MONTH",
    MIN_IN_A_DAY: 1,
  },
  { label: "Once in 2 months", value: "ONCE_IN_2_MONTHS", MIN_IN_A_DAY: 1 },
  { label: "Once in 3 months", value: "ONCE_IN_3_MONTHS", MIN_IN_A_DAY: 1 },
  { label: "Once a year", value: "ONCE_A_YEAR", MIN_IN_A_DAY: 1 },
  { label: "Two times a year", value: "TWO_TIMES_A_YEAR", MIN_IN_A_DAY: 1 },
  { label: "Three times a year", value: "THREE_TIMES_A_YEAR", MIN_IN_A_DAY: 1 },
  { label: "Once in 2 years", value: "ONCE_IN_2_YEARS", MIN_IN_A_DAY: 1 },
  { label: "Once in 3 years", value: "ONCE_IN_3_YEARS", MIN_IN_A_DAY: 1 },
  { label: "SOS", value: "SOS", MIN_IN_A_DAY: 0 },
  { label: "STAT", value: "STAT", MIN_IN_A_DAY: 0 },
];
